import type jsPDF from 'jspdf';
import { buildCompanyForPdf } from '../../services/pdf/companyForPdf';
import {
    generatePlanungshinweisPdf,
    type PlanungshinweisPdfDaten,
    type PlanungshinweisPdfOptionen,
} from '../../services/pdf/generatorPlanungshinweis';
import type { Anschluss, PdfKontext } from './planungIntegration';

/**
 * Anschluss des Bedenkenanzeige-Generators an die Oberflaeche — dasselbe
 * Muster wie `baueKlaerungslistePdf` in `planungIntegration.ts`: jsPDF und
 * die Briefkopfaufbereitung werfen, die Komponente soll nicht in einem `try`
 * stehen, und ein kaputtes Logo im Firmenprofil darf nicht den Editor
 * weissbrennen.
 *
 * `buildCompanyForPdf` ist PFLICHT — rohe Stammdaten durchzureichen ergibt
 * ein Blatt ohne Briefpapier, und das faellt erst beim Empfaenger auf.
 */
export const baueHinweisPdf = (
    hinweis: PlanungshinweisPdfDaten,
    kontext: PdfKontext,
    optionen: PlanungshinweisPdfOptionen,
): Anschluss<jsPDF> => {
    try {
        const company = buildCompanyForPdf(
            kontext.company as never,
            kontext.quoteConfig as never,
            kontext.invoiceConfig as never,
        );
        return { status: 'ok', wert: generatePlanungshinweisPdf(hinweis, company, optionen) };
    } catch (e) {
        return {
            status: 'fehler',
            fehler: `Das PDF konnte nicht erzeugt werden: ${e instanceof Error ? e.message : String(e)}`,
        };
    }
};

/**
 * Firmenname aus den rohen Stammdaten — fuer die Grusszeile des Mailtexts.
 * Nur eine Zeichenkette zaehlt; alles andere ist „keine Firma".
 */
export const firmaAusKontext = (kontext: PdfKontext | null | undefined): string => {
    const name = (kontext?.company as { name?: unknown } | null | undefined)?.name;
    return typeof name === 'string' ? name.trim() : '';
};
